"use client";

import dynamic from "next/dynamic";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
// import { L } from "leaflet";
import "./Legend.css";
import "leaflet/dist/leaflet.css";

// const L = dynamic(() => import("leaflet").then((m) => m.L), {
//   ssr: false,
// });

function Legend({ categories }) {
  const map = useMap();

  useEffect(() => {
    const legend = L.control({ position: "bottomright" });

    legend.onAdd = function () {
      const div = L.DomUtil.create("div", "info legend");

      const legendTitle = document.createElement("h3");
      legendTitle.innerText = "Number of Documents";
      const listContainer = document.createElement("div");
      listContainer.className = "listContainer";

      listContainer.appendChild(legendTitle);

      for (const category of categories) {
        const item = document.createElement("div");
        item.className = "listItem";

        const color = document.createElement("span");
        color.style.backgroundColor = category.color;

        const label = document.createElement("p");
        label.innerHTML = category.label;

        item.append(color, label);
        listContainer.appendChild(item);
      }

      div.appendChild(listContainer);
      return div;
    };

    legend.addTo(map);

    // Cleanup function to remove the control when the component unmounts
    return () => {
      legend.remove();
    };
  }, [map, categories]);

  return null;
}

export default Legend;
